const searchCategoryResults = document.querySelectorAll('.website-search-results');
const searchCategoryButtons = document.querySelectorAll('.search-category-toggle');

searchCategoryButtons.forEach(button => {
  button.addEventListener('click', function(event) {
    let category = event.target.dataset.showSearchCategory || 'pages';

    searchCategoryButtons.forEach(button => button.classList.toggle('btn--blue'));

    searchCategoryResults.forEach(panel => {
      if (panel.dataset.searchCategory === category) {
        panel.style.display = 'block';
      } else {
        panel.style.display = 'none';
      }
    });
  });
});

